module.exports = __webpack_public_path__ + "img/DeltaWing.9abce732.svg";